export const BAOGO_SERVER_ADDRESS = 'https://baogo.turingsenseai.com' // baogo 生产地址
export const BAOGO_SERVER_ADDRESS_TEST = 'https://baogotest.turingsenseai.com' // 联调地址

export const OPEN_SERVER_ADDRESS = 'https://openplatform.turingsenseai.com' // baogo 生产地址
export const OPEN_SERVER_ADDRESS_TEST = 'https://openplatform-test.turingsenseai.com' // 联调地址

export const STOCK_SERVER_ADDRESS = "https://stockcloud.turingsenseai.com"  // stock 生产地址
export const STOCK_SERVER_ADDRESS_TEST = "https://stockcloud-test.turingsenseai.com"  // stock 测试地址

export const AISERVICE_SERVER_ADDRESS = "https://aiservice.turingsenseai.com"  // aiservice 生产地址
export const AISERVICE_SERVER_ADDRESS_TEST = "https://aiservice-test.turingsenseai.com"  // aiservice 测试地址

export const USERCENTER_SERVER_ADDRESS = "https://user-service.turingsenseai.com"
export const USERCENTER_SERVER_ADDRESS_TEST = "https://user-service-test.turingsenseai.com"
export const EX_SERVER_ADDRESS_TEST = "https://experience-service-test.turingsenseai.com"
export const EX_SERVER_ADDRESS = "https://experience-service.turingsenseai.com"
export const CUSTOMS_SERVER_ADDRESS_TEST = "https://customs-service-test.turingsenseai.com"
export const CUSTOMS_SERVER_ADDRESS = "https://customs-service.turingsenseai.com"

export const ALI_SERVER_ADDRESS = "https://ali-appraisal.turingsenseai.com"
export const ALI_SERVER_ADDRESS_TEST = "https://ali-appraisal-test.turingsenseai.com"



const devEnv = process.env.NODE_ENV === 'development'

// 是否测试环境
export const isTestEnv = devEnv ? true : (!!location.host.includes('test'))

export const SERVER_DOMAIN = isTestEnv ? BAOGO_SERVER_ADDRESS_TEST : BAOGO_SERVER_ADDRESS
export const STOCK_SERVER_DOMAIN = isTestEnv ? STOCK_SERVER_ADDRESS_TEST : STOCK_SERVER_ADDRESS
export const OPEN_SERVER_DOMAIN = isTestEnv ? OPEN_SERVER_ADDRESS_TEST : OPEN_SERVER_ADDRESS
export const AISERVICE_DOMAIN= isTestEnv ? AISERVICE_SERVER_ADDRESS_TEST :  AISERVICE_SERVER_ADDRESS
export const USERCENTER_DOMAIN = isTestEnv ? USERCENTER_SERVER_ADDRESS_TEST : USERCENTER_SERVER_ADDRESS
export const EX_DOMAIN = isTestEnv ? EX_SERVER_ADDRESS_TEST : EX_SERVER_ADDRESS
export const CUSTOMS_DOMAIN = isTestEnv ? CUSTOMS_SERVER_ADDRESS_TEST : CUSTOMS_SERVER_ADDRESS;
export const ALI_DOMAIN = isTestEnv ? ALI_SERVER_ADDRESS_TEST : ALI_SERVER_ADDRESS;



export const HOST_ADDRESS = () => `https://baoh5${isTestEnv ? 'test' : ''}.turingsenseai.com/#/`
export const SPLIT_H5_ADDRESS = () => `https://split-h5${isTestEnv ? '-test' : ''}.turingsenseai.com/#/`
export const REPORT_CONTACT_EMAIL = 'kefu@turingsenseai.com'
export const REPORT_COMPANY_WEBSITE = 'https://www.turingsenseai.com'

// proto 协议模块
export const PROTO_MODULE = {
  AI_SERVICE: 'AI_SERVICE',
  ORDER: 'ORDER',
  PRODUCT: 'PRODUCT',
  USER: 'USER',
  WALL: 'WALL',
  ROOT: 'ROOT',
  LOTTERY: 'LOTTERY',
  SEARCH: 'SEARCH',
  OFFLINE_IDENTIFY: 'OFFLINE_IDENTIFY',
  CUSTOMS: 'CUSTOMS',
  ALI: 'ALI',
}

/** ------------------------------------------------------------------- **/
/** -----------|--------------------------------------------|---------- **/
/** -----------|                  常量列表配置                |---------- **/
/** -----------|--------------------------------------------|---------- **/
/** ------------------------------------------------------------------- **/

/**
 * 数组转对象[{ label: 'a', value: '0' }] => { 0: 'a' }
 * @param {Array} list
 */
const listToMaper = (list) => list.reduce((x, y) => ({ ...x, ...{ [y.value]: y } }), {})

// 钱包 流水事件
export const WalletRunningCountTypeList = [
  { label: '个人出售', value: 1, addOrsubt: '+', wxDetailLink: (orderID) => `/subPackages/personal/sale/order-detail/index?orderID=${orderID}` },
  { label: '提现', value: 2, addOrsubt: '-' },
  { label: '平台回收', value: 3, addOrsubt: '+', wxDetailLink: (orderID) => `/subPackages/personal/recycle/details?orderNo=${orderID}` },
  { label: '寄卖-尾款', value: 4, addOrsubt: '+', wxDetailLink: (orderID) => `/subPackages/personal/consign/details?orderNo=${orderID}` },
  { label: '寄卖-预付金', value: 5, addOrsubt: '+', wxDetailLink: (orderID) => `/subPackages/personal/consign/details?orderNo=${orderID}` },
  { label: '交换-商品差价', value: 6, addOrsubt: '' },
  { label: '云仓出售', value: 7, addOrsubt: '+' },
  { label: '活动激励', value: 8, addOrsubt: '+' },
  { label: '佣金', value: 9, addOrsubt: '+', urlLink: (orderID) => `https://baoh5${isTestEnv ? 'test' : ''}.turingsenseai.com/distribution/orders/detail-push?orderNo=${orderID}` },
  { label: '线下鉴定回收', value: 10, addOrsubt: '+' },
]
export const WalletRunningCountTypeMapper = listToMaper(WalletRunningCountTypeList)

export const SPLIT_H5_PAGES = {
  splitProduct: (params) => `${SPLIT_H5_ADDRESS()}pages/counter/result?orderNo=${params.orderNo}&res=${params.result}`
}

export const USER_FROM = {
  LANGJIE: '1', // 浪姐活动
  JIANDINGLAXIN: '2', // 鉴定拉新活动
  QIXI: '3',  // 七夕鉴定兑好礼活动
  ZHIER: '4',  // 只二小程序
  MIAOSHA: '5',  // 秒杀活动
  ZIJIE: '6',  // 包小鉴-字节小程序
  KANJIA: '7',  // 七夕砍价活动
  JIANDING_APP: '8',  // 鉴定APP
  BAIDU_MINI: '9',  // 百度小程序
  YUNCANG_WX_MINI: '10',  // 云仓微信小程序
  KUAISHOU_MINI: '11',  // 快手小程序
  XIANYU_GUOQING: '12',  // 闲鱼国庆活动
  FENXIAO_H5: '13',  // 分销H5
  BAOZHAN: '14',  // 包展
  CAIGOU: '15',   // 采购
}
